import { lockOptions } from "./LockIcons";

const LockPreview = () => {
  return (
    <div className="lock-preview-page">
      <h1 className="lock-preview-title">Slot-varianten</h1>
      <p className="lock-preview-sub">
        Klik op een tegel om hem groter te zien. Geef de naam door zodat we hem
        instellen als slot voor wachtwoord-tegels.
      </p>
      <div className="lock-preview-grid">
        {lockOptions.map(({ name, id, Component }) => (
          <div key={id} className="lock-preview-card">
            <div className="lock-preview-tile">
              <img
                src={"/bingoCircle.png?v=3"}
                alt="circle"
                className="lock-preview-circle"
              />
              <Component />
            </div>
            <div className="lock-preview-meta">
              <strong>{name}</strong>
              <code>{id}</code>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LockPreview;
